module.exports = __webpack_public_path__ + "img/camera_icon.318a44eb.svg";